module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fi-item block w-full odd:bg-white even:bg-[#F7F9FC]",
    class: (_vm.fibsdd.affectation_user === _vm.idUser) ? 'border-l-[6px] border-solid border-[#0C2A5C]' : '',
    attrs: {
      "id": _vm.fibsdd.id
    }
  }, [_c('router-link', {
    staticClass: "block w-full p-4 flex items-center gap-4",
    attrs: {
      "to": _vm.linkFi
    }
  }, [_c('div', {
    staticClass: "flex-1 min-w-0"
  }, [_c('div', {
    staticClass: "flex items-start flex-wrap gap-2"
  }, [_c('h2', [_c('span', {
    staticClass: "inline-flex flex-col items-start gap-1"
  }, [(_vm.fibsdd.affectation_user === _vm.idUser) ? [_c('span', {
    staticClass: "inline-flex items-center gap-2 text-secondary italic text-sm"
  }, [_c('div', {
    staticClass: "bg-secondary rounded-full h-5 w-5 flex-shrink-0 grid place-items-center"
  }, [_c('i', {
    staticClass: "inline-block h-4 w-4 mask mask-user bg-white"
  })]), _vm._v("\n                                Fiche affectée\n                            ")])] : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "flex items-center gap-2"
  }, [_c('span', {
    staticClass: "font-bold text-xl text-bleu-moyen uppercase"
  }, [_vm._v("\n                                " + _vm._s(_vm.fibsdd.numero) + "\n                            ")]), _vm._v(" "), (_vm.fibsdd.ordre_travail != null) ? _c('p', {
    staticClass: "text-md text-secondary"
  }, [_vm._v("\n                                - " + _vm._s(_vm.fibsdd.ordre_travail) + "\n                            ")]) : _vm._e()])], 2)])]), _vm._v(" "), _c('p', {
    staticClass: "text-sm text-gris"
  }, [(_vm.detenteur) ? [_vm._v("\n                    " + _vm._s(_vm.detenteur.raison_sociale) + " - " + _vm._s(_vm.detenteur.adresse)), _c('br', {
    staticClass: "hidden sm:block"
  }), _vm._v("\n                    " + _vm._s(_vm.detenteur.code_postal) + " - " + _vm._s(_vm.detenteur.ville) + "\n                ")] : [_vm._v("\n                    Chargement en cours...\n                ")]], 2), _vm._v(" "), (_vm.installation) ? _c('p', {
    staticClass: "text-md text-secondary font-bold"
  }, [_vm._v("\n                " + _vm._s(_vm.installation.nom) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "bg-primary rounded-full h-9 w-9 flex-shrink-0 grid place-items-center"
  }, [_c('i', {
    staticClass: "inline-block h-6 w-6 mask mask-arrow-left bg-white rotate-180"
  })]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fibsdd.supprimable === true),
      expression: "fibsdd.supprimable === true"
    }],
    staticClass: "bg-red-500 rounded-full h-9 w-9 flex-shrink-0 grid place-items-center",
    attrs: {
      "type": "button",
      "aria-label": "Supprimer"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.delFi(_vm.fibsdd.id)
      }
    }
  }, [_c('i', {
    staticClass: "inline-block h-6 w-6 mask mask-trash bg-white"
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cd2a55e6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fiches/bsdd/FibsddItem.vue
// module id = 1052
// module chunks = 0